import { appAbilitiesSchema } from '@acme/auth'
import { zod } from '@acme/core'
import { z } from 'zod'
import ApiService from '../api.service'

export type PerfilPermissao = z.infer<typeof zod.PerfilPermissaoSchema> & {
    ModuloPermissao: z.infer<typeof zod.ModuloPermissaoSchema>[]
}

export const createPerfilPermissaoSchema = zod.PerfilPermissaoSchema.omit({
    updatedAt: true,
    createdAt: true,
    id: true,
    clienteId: true,
})
    .extend({
        appAbilities: appAbilitiesSchema,
    })
    .transform(data => {
        return {
            ...data,
            ModuloPermissao: data.appAbilities?.map(([abilities, subject]) => ({
                subject,
                create: abilities.includes('create'),
                read: abilities.includes('read'),
                update: abilities.includes('update'),
                delete: abilities.includes('delete'),
            })),
        }
    })

export const updatePerfilPermissaoSchema = createPerfilPermissaoSchema

export const permissoes = new ApiService<PerfilPermissao>('permissoes')
